import React, { useEffect, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import BakeasySimpleTable, {
  HeadCell,
} from '../../components/tables/BakeasySimpleTable';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import BakeasyHeaderLabel from '../../components/lables/BakeasyHeaderLabel';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import { t } from 'i18next';
import {
  BakeasyButtonCancel,
  BakeasyUpdateInvoiceDetails,
} from '../../components/buttons/BakeasyButton';
import {
  ShipTo,
  YesNo,
  ShippingCalculation,
} from '../../components/dropdowns/BakeasySelect';
import {
  Name,
  Address,
  City,
  State,
  Pincode,
  Country,
  Number,
} from '../../components/textfields/BakeasyTextFields';
import i18n from '../../languages/languages';
import { Close } from '@mui/icons-material';
import { BakeasyAutoCompleteShippingMethod } from '../../components/dropdowns/BakeasyAutoComplete';
import { shippingMethodsState } from '../../redux_store/slices/shippingMethodsSlice';
import { createInvoice } from '../../redux_store/slices/invoiceSlice';
import { clearShippingsState } from '../../redux_store/slices/shippingsSlice';

export const InvoiceSummary = (props: any) => {
  const { state } = useLocation();
  let myContext = React.useContext(AppContext);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [selectedShipTo, setSelectedShipTo] = useState<any>('');
  const [shipToName, setShipToName] = useState<any>('');
  const [shipToCompanyName, setShipToCompanyName] = useState<any>('');
  const [shipToAddress, setShipToAddress] = useState<any>('');
  const [shipToCity, setShipToCity] = useState<any>('');
  const [shipToPostCode, setShipToPostCode] = useState<any>('');
  const [shipToCountry, setShipToCountry] = useState<any>('');
  const [shipToState, setShipToState] = useState<any>('');

  const [selectedPreferredShippingMethod, setSelectedPreferredShippingMethod] =
    useState<any>('');
  const [selectedShippingCharge, setSelectedShippingCharge] = useState<any>('');
  const [selectedShippingCalculation, setSelectedShippingCalculation] =
    useState<any>('');
  const [shippingCharges, setShippingCharges] = useState<any>('');
  const [ordersList, setOrdersList] = useState<any[]>(
    state?.selectedOrders?.length ? state.selectedOrders : []
  );
  let _shippingMethodsState = useAppSelector(shippingMethodsState);

  useEffect(() => {
    if (props?.params?.data) {
      setData(props?.params?.data);
    }
  }, [props?.isEdit?.params?.data]);

  function handleClose() {
    myContext.setDialog({ open: false });
  }

  const tableHeaders: HeadCell[] = [
    {
      id: 'productName',
      label: 'PRODUCT_NAME',
      numeric: false,
      disablePadding: false,
    },
    {
      id: 'quantity',
      label: 'QUANTITY',
      numeric: false,
      disablePadding: false,
    },
    {
      id: 'invoicedQuantity',
      label: 'INVOICE_QUANTITY',
      numeric: false,
      disablePadding: false,
    },
  ];

  function openCancelInvoiceSummary() {
    myContext.setConfirmDialog({
      open: true,
      title: t('CONFIRMATION'),
      message: t('ORDER_CANCEL_CONFIRM_MESSAGE'),
      onYesClick: (event: any, param: string | undefined) => {
        handleClose();
      },
      onNoClick: (event: any) => {},
    });
  }

  function setData(data: any) {
    if (data?.products?.length > 0) {
      const orders = data?.products?.map((item: any) => {
        item.unitPrice = item?.price;
        item.quantity = item?.quantity;
        item.shippingQuantity = item?.shippingQuantity;
        item.invoicedQuantity = item?.invoicedQuantity;
        item.price = item?.price;
        item.totalPrice = item?.totalPrice;
        item.backOrderChecked = false;
        item.processOrderChecked = false;
        item.cancelOrderChecked = false;
        return item;
      });
      setOrdersList(orders);

      setSelectedShipTo(data?.selectedValue?.shipTo);
      setShipToName(data?.selectedValue?.shipToInfo?.name);
      setShipToCompanyName(data?.selectedValue?.shipToInfo?.companyName);
      setShipToAddress(data?.selectedValue?.shipToInfo?.companyAddress);
      setShipToCity(data?.selectedValue?.shipToInfo?.city);
      setShipToState(data?.selectedValue?.shipToInfo?.state);
      setShipToPostCode(data?.selectedValue?.shipToInfo?.zipCode);
      setShipToCountry(data?.selectedValue?.shipToInfo?.country);
      setSelectedShippingCharge(
        data?.selectedValue?.shippingCharges
          ? i18n.language === 'fr'
            ? 'Oui'
            : 'Yes'
          : i18n.language === 'fr'
            ? 'Non'
            : 'No'
      );
      setSelectedShippingCalculation(data?.selectedValue?.shippingRateType);
      setShippingCharges(data?.selectedValue?.shippingRate);
      setSelectedPreferredShippingMethod(
        data?.selectedValue?.preferredShippingMethod
          ? { methodName: data?.selectedValue?.preferredShippingMethod }
          : null
      );
    }
  }

  function handleCheckInvoiceQuantityChange(row: any) {
    let filteredRowIndex1 = ordersList.findIndex(
      (tableRow: any) => tableRow.productId === row?.productId
    );
    if (filteredRowIndex1 >= 0) {
      let a = ordersList;
      a[filteredRowIndex1] = row;
      setOrdersList([...a]);
    }
  }

  const handleInvoiceQuantity = (row: any, value: any) => {
    handleCheckInvoiceQuantityChange(row);
  };

  async function createPayload() {
    // if (!checkValidity()) {
    //   return false;
    // }
    let payload: any = {
      orderId: props?.params?._id,
      shipTo: selectedShipTo,
      shipToInfo: {
        name: shipToName,
        companyName: shipToCompanyName,
        companyAddress: shipToAddress,
        city: shipToCity,
        zipCode: shipToPostCode,
        state: shipToState,
        country: shipToCountry,
      },
      shippingCharges:
        selectedShippingCharge === 'Yes' || selectedShippingCharge === 'Oui'
          ? true
          : false,
      shippingRateType: selectedShippingCalculation,
      shippingRate: shippingCharges,
      preferredShippingMethod: selectedPreferredShippingMethod?.methodName,
      products: ordersList.map((item: any) => {
        return {
          categoryId: item?.categoryId,
          subCategoryId: item?.subCategoryId,
          productId: item?.productId,
          // product_id: item?.product_id,
          quantity: item?.quantity,
          price: item?.unitPrice,
          productName: item?.productName,
          totalPrice: parseFloat(
            (
              parseFloat(item?.shippingQuantity) * parseFloat(item?.price)
            ).toFixed(2)
          ),
          shippingQuantity: item?.shippingQuantity,
          invoicedQuantity: item?.shippingQuantity,
        };
      }),
    };

    return payload;
  }

  return (
    <>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('CONFIRM_INVOICE_DETAILS')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>

      <DialogContent dividers>
        <Grid>
          <Grid sx={{ p: 2 }}>
            <Grid>
              {ordersList?.length > 0 && (
                <BakeasySimpleTable
                  headers={tableHeaders}
                  tableData={ordersList}
                  handleInvoiceQuantityChanged={handleInvoiceQuantity}
                />
              )}
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container>
            <BakeasyHeaderLabel message="SHIPPING_DETAILS" />
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <ShipTo
                disabled={true}
                value={selectedShipTo}
                onChange={(event: any) => {
                  setSelectedShipTo(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Name
                disabled={true}
                value={shipToName}
                onChange={(event: any) => {
                  setShipToName(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Name
                disabled={true}
                label={t('COMPANY_NAME')}
                value={shipToCompanyName}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Address
                label={t('COMPANY_ADDRESS')}
                disabled={true}
                value={shipToAddress}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <City value={shipToCity} disabled={true} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <State
                value={
                  shipToState
                    ? t(`${shipToState?.toUpperCase().replace(/\s+/g, '_')}`)
                    : shipToState
                }
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Pincode value={shipToPostCode} disabled={true} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Country
                value={
                  shipToCountry
                    ? t(`${shipToCountry?.toUpperCase().replace(/\s+/g, '_')}`)
                    : shipToCountry
                }
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} pl={2} mt={0}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <YesNo
                disabled={true}
                label={t('SHIPPING_CHARGE')}
                value={selectedShippingCharge}
                onChange={function (event: any): void {
                  setSelectedShippingCharge(event?.target?.value);
                  setSelectedShippingCalculation('');
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <ShippingCalculation
                disabled={true}
                value={
                  selectedShippingCalculation
                    ? t(
                        `${selectedShippingCalculation?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : selectedShippingCalculation
                }
                onChange={(event: any) => {
                  setSelectedShippingCalculation(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Number
                label={t('SHIPPING_CHARGES')}
                maxLength={4}
                disabled={true}
                value={shippingCharges}
                onChange={(event: any) => {
                  setShippingCharges(event.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyAutoCompleteShippingMethod
                disabled={true}
                required={false}
                value={selectedPreferredShippingMethod}
                options={
                  _shippingMethodsState.value?.data?.length > 0
                    ? _shippingMethodsState.value?.data
                    : null
                }
                onAddClick={(props: any) => {
                  //openAddShippingMethodDialog(props);
                }}
                onChange={(newValue: any) => {
                  // if (typeof newValue === 'string' && newValue?.length > 2) {
                  //   dispatch(fetchShippingMethods({ page: 1, limit: 5, search: newValue }));
                  // }
                  // if (typeof newValue === 'string' && newValue?.length === 0) {
                  //   dispatch(fetchShippingMethods({ page: 1, limit: 5 }));
                  // }
                  // if (typeof newValue === 'object' && newValue?.id !== 0) {
                  //   setSelectedPreferredShippingMethod(newValue);
                  // }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ margin: 1 }}>
        <Grid container spacing={2}>
          <Grid item>
            <BakeasyButtonCancel
              onClick={function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): void {
                openCancelInvoiceSummary();
              }}
            />
          </Grid>
          <Grid item>
            <BakeasyUpdateInvoiceDetails
              onClick={async function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): Promise<void> {
                let payload = await createPayload();
                await dispatch(createInvoice(payload));
                dispatch(clearShippingsState());
                myContext.setDialog({ open: false });
                navigate(-1);
              }}
            />
          </Grid>
        </Grid>
      </DialogActions>
    </>
  );
};
